import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "recipe recipe--list" }
const _hoisted_2 = {
  key: 0,
  class: "recipe__left-column"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "recipe__content-box" }
const _hoisted_6 = {
  key: 0,
  class: "recipe__content-box-title"
}
const _hoisted_7 = {
  key: 1,
  class: "recipe__content-box-description"
}
const _hoisted_8 = { class: "recipe__content-box-cta" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "recipe__right-column"
}
const _hoisted_11 = { class: "recipe__wrapper" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  class: "recipe__image-wrap"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "recipe__image-wrap"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "recipe__name" }
const _hoisted_18 = {
  key: 2,
  class: "recipe__loading-spinner"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.recipes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.recipes[0].Image1.length)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $setup.recipes[0]?.Image1[0]?.Url,
                alt: "",
                class: "recipe__main-image"
              }, null, 8 /* PROPS */, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: $setup.fallbackImage,
                class: "recipe__main-image",
                alt: "no image available"
              }, null, 8 /* PROPS */, _hoisted_4)),
          _createElementVNode("div", _hoisted_5, [
            ($setup.recipes[0]?.Title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.recipes[0]?.Title), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.recipes[0]?.Text2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.recipes[0]?.Text2), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                href: `${$setup.translations.RecipeDetailUrl}/${$setup.recipes[0]?.UrlName}`,
                class: "btn btn-primary"
              }, _toDisplayString($setup.translations.ViewRecipe), 9 /* TEXT, PROPS */, _hoisted_9)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.recipes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_perfect_scrollbar, null, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recipes, (recipe) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "recipe__slide",
                    key: recipe.Id
                  }, [
                    _createElementVNode("a", {
                      href: `${$setup.translations.RecipeDetailUrl}/${recipe?.UrlName}`,
                      class: "recipe__link"
                    }, [
                      (recipe.Carouselmage.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("img", {
                              src: recipe.Carouselmage[0]?.Thumbnails?.filter(e => e.Title === 'medium')?.[0]?.Url || recipe.Carouselmage[0]?.Url,
                              alt: recipe.Carouselmage[0]?.AlternativeText,
                              class: "recipe__image"
                            }, null, 8 /* PROPS */, _hoisted_14)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("img", {
                              src: $setup.fallbackImage,
                              class: "recipe__image",
                              alt: "no image available"
                            }, null, 8 /* PROPS */, _hoisted_16)
                          ])),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(recipe.Title), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_12)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.recipesLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
      : _createCommentVNode("v-if", true)
  ]))
}